import { SortConfig } from '@celito.clients/list-view-engine';

export const defaultSortConfig: SortConfig = {
  attribute: 'createdAtUtc',
  order: 'DESC',
};
